var _mask, _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 21,
    viewBox: "0 0 32 21",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 9,
    maskUnits: "userSpaceOnUse",
    width: 4,
    x: 14,
    y: 6
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m16 6.2572c-1.2215 1.00879-2 2.5349-2 4.2428 0 1.708.7785 3.2341 2 4.2429 1.2215-1.0088 2-2.5349 2-4.2429 0-1.7079-.7785-3.23401-2-4.2428z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.5c0-.828427.671573-1.5 1.5-1.5h29c.8284 0 1.5.671573 1.5 1.5v18c0 .8284-.6716 1.5-1.5 1.5h-29c-.828427 0-1.5-.6716-1.5-1.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.5 16c3.0376 0 5.5-2.4624 5.5-5.5 0-3.03757-2.4624-5.5-5.5-5.5-3.03757 0-5.5 2.46243-5.5 5.5 0 3.0376 2.46243 5.5 5.5 5.5z",
    fill: "#d8232a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 14.7428c.9509.7854 2.1704 1.2572 3.5 1.2572 3.0376 0 5.5-2.4624 5.5-5.5 0-3.03757-2.4624-5.5-5.5-5.5-1.3296 0-2.5491.47182-3.5 1.25716 1.2215 1.00879 2 2.5349 2 4.24284 0 1.7079-.7785 3.234-2 4.2428z",
    fill: "#ed9f2d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 6.2572c-1.2215 1.00879-2 2.5349-2 4.2428 0 1.708.7785 3.2341 2 4.2429 1.2215-1.0088 2-2.5349 2-4.2429 0-1.7079-.7785-3.23401-2-4.2428z",
    fill: "#d8232a"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m13 7h6v1h-6zm0 2h6v1h-6zm6 2h-6v1h6zm-6 2h6v1h-6zm6 2h-6v1h6z",
    fill: "#ed9f2d",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m0 1.5c0-.828427.671573-1.5 1.5-1.5h29c.8284 0 1.5.671573 1.5 1.5v18c0 .8284-.6716 1.5-1.5 1.5h-29c-.828427 0-1.5-.6716-1.5-1.5z",
    fill: "#e5e5e5",
    fillOpacity: 0.01,
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.be0e56b423d25dec91bfdd5ee2a9e0d3.svg";
export { ForwardRef as ReactComponent };